import config from "./config";

function sendGtagEvent(eventCategory, eventLabel, value) {
  window.gtag("event", eventCategory, {
    event_category: eventCategory,
    event_label: eventLabel,
    value: value,
    send_to: config.gaKey,
  });
}

export default sendGtagEvent;
